/* ══ O MOVIMENTO DAS CAMADAS (V1913 · a demo aprovada: documentacao/demos-aprovadas/demo-movimento-pecas-v2.html, a opção "Suave") ══════
 * Ele, 18/10/2026: "vamos no suave · quando implantarmos, tira todas as animações de modais antigos e valida essa" · "vou querer animação
 * sempre ativa". Quem chama é o observador das camadas (utils/camadas.js): toda camada que aparece ENTRA com o movimento, e toda camada que
 * sai SAI com ele — a folha v2, o ⋯ (folha e balão), a ficha grande, a confirmação e o modal antigo, sem ligar nada em cada tela.
 *   · SEMPRE ATIVA: não segue o "reduzir movimento" do aparelho, e é desenhada quadro a quadro (requestAnimationFrame), não por animação de
 *     CSS — o celular dele corta as animações de CSS (achado na demo: com elas, a folha só aparecia).
 *   · no celular (< 900 px) a caixa SOBE de baixo (.32 s, sem balanço) e DESCE ao sair (.22 s);
 *   · no computador a caixa APARECE no meio, subindo 16 px e indo de 96 % a 100 % (.22 s), e apaga ao sair;
 *   · o balão do ⋯ (.mn-balao) CRESCE a partir do botão (de 90 %, .15 s) e apaga ao sair (.12 s);
 *   · o véu (a própria camada) escurece em .2 s e clareia em .18 s.
 * A SAÍDA: se a tela marca a camada com .closing antes de tirá-la (o useSaidaSuave, 200 ms), ela sai ali mesmo; se a camada é tirada de uma
 * vez, sai uma CÓPIA dela no mesmo lugar (o "fantasma"), que some no fim do movimento — a tela de verdade já foi embora. */

const CURVA_ENTRA = [0.2, 0.8, 0.2, 1];
const CURVA_SAI = [0.4, 0, 1, 1];

function bezier(x1, y1, x2, y2) {
  const bx = (t) => 3 * (1 - t) * (1 - t) * t * x1 + 3 * (1 - t) * t * t * x2 + t * t * t;
  const by = (t) => 3 * (1 - t) * (1 - t) * t * y1 + 3 * (1 - t) * t * t * y2 + t * t * t;
  return (x) => { let lo = 0, hi = 1, t = x; for (let i = 0; i < 24; i++) { t = (lo + hi) / 2; if (bx(t) < x) lo = t; else hi = t; } return by(t); };
}
/* desenha de 0 a 1 ao longo de "ms", quadro a quadro; devolve como parar */
function mexer(ms, curva, desenhar, fim) {
  const f = bezier(...curva); let ini = null, parado = false;
  const passo = (agora) => { if (parado) return; if (ini === null) ini = agora; const k = Math.min(1, (agora - ini) / ms); desenhar(f(k));
    if (k < 1) requestAnimationFrame(passo); else if (fim) fim(); };
  desenhar(f(0)); requestAnimationFrame(passo);
  return () => { parado = true; };
}
const celular = () => window.innerWidth < 900;
/* a caixa da camada: o primeiro filho (a folha .mn, a .modal, a .md-cx, a .conf-caixa, a ficha) */
const caixaDe = (camada) => camada.firstElementChild;
/* a caixa encosta embaixo (a folha que sobe)? no celular, quase toda caixa encosta; a ficha de tela inteira também sobe */
const sobeDeBaixo = (camada, caixa) => celular() && caixa && !caixa.classList.contains('mn-balao');

export function entrar(camada) {
  const caixa = caixaDe(camada); if (!caixa || camada.dataset.mov === 'entrando') return;
  camada.dataset.mov = 'entrando';
  const balao = caixa.classList.contains('mn-balao');
  const veuTransparente = getComputedStyle(camada).backgroundColor === 'rgba(0, 0, 0, 0)';
  if (!veuTransparente) { camada.style.opacity = '0'; mexer(200, CURVA_ENTRA, (v) => { camada.style.opacity = String(v); }, () => { camada.style.opacity = ''; }); }
  const t0 = caixa.style.transform || '';
  const pronto = () => { caixa.style.transform = t0; caixa.style.opacity = ''; caixa.style.transformOrigin = ''; delete camada.dataset.mov; };
  if (balao) {
    caixa.style.transformOrigin = 'top right';
    mexer(150, CURVA_ENTRA, (v) => { caixa.style.opacity = String(Math.min(1, v * 1.5)); caixa.style.transform = `${t0} scale(${0.9 + 0.1 * v})`; }, pronto);
  } else if (sobeDeBaixo(camada, caixa)) {
    mexer(320, CURVA_ENTRA, (v) => { caixa.style.transform = `${t0} translateY(${100 * (1 - v)}%)`; }, pronto);
  } else {
    mexer(220, CURVA_ENTRA, (v) => { caixa.style.opacity = String(Math.min(1, v * 1.3)); caixa.style.transform = `${t0} translateY(${16 * (1 - v)}px) scale(${0.96 + 0.04 * v})`; }, pronto);
  }
}

/* a saída de um elemento que ainda está na tela (a camada viva com .closing, ou o fantasma) */
function sairNoLugar(camada, ms, fim) {
  const caixa = caixaDe(camada); camada.dataset.mov = 'saindo';
  mexer(Math.min(ms, 180), CURVA_SAI, (v) => { camada.style.opacity = String(1 - v); });
  if (!caixa) { setTimeout(() => fim && fim(), ms); return; }
  const t0 = caixa.style.transform || '';
  if (caixa.classList.contains('mn-balao')) mexer(Math.min(ms, 120), CURVA_SAI, (v) => { caixa.style.opacity = String(1 - v); }, fim);
  else if (sobeDeBaixo(camada, caixa)) mexer(ms, CURVA_SAI, (v) => { caixa.style.transform = `${t0} translateY(${100 * v}%)`; }, fim);
  else mexer(ms, CURVA_SAI, (v) => { caixa.style.opacity = String(1 - v); caixa.style.transform = `${t0} translateY(${8 * v}px)`; }, fim);
}

/* a tela marcou a camada com .closing (o useSaidaSuave segura 200 ms): sai ali mesmo */
export function sairComClosing(camada) {
  if (camada.dataset.mov === 'saindo') return;
  camada.__saiu = true; sairNoLugar(camada, 200);
}

/* a camada foi tirada de uma vez: sai a cópia dela, no mesmo lugar, e some no fim. "removido" é o que saiu da página: a própria camada, ou
   o invólucro dela (o portal das folhas v2 tira o <div class="s5v2"> que a embrulha — a cópia leva o invólucro, para valer o mesmo CSS).
   Devolve como sumir na hora (a camada que volta). */
export function sairComFantasma(camada, removido, pai, proximo) {
  if (camada.__saiu || !removido || !pai || !pai.isConnected) return () => {};
  const embrulho = removido !== camada;
  if (embrulho && removido.children.length !== 1) return () => {};   // saiu uma tela inteira (navegou): sem fantasma
  const f = removido.cloneNode(true); f.setAttribute('aria-hidden', 'true'); f.dataset.fantasma = '1'; f.style.pointerEvents = 'none';
  const camadaF = embrulho ? f.querySelector('[class]') && [...f.querySelectorAll('*')].find(n => n.className === camada.className) : f;
  if (!camadaF) return () => {};
  if (embrulho) camadaF.dataset.fantasma = '1';
  try { pai.insertBefore(f, proximo && proximo.parentNode === pai ? proximo : null); } catch { return () => {}; }
  const sumir = () => f.remove();
  sairNoLugar(camadaF, 220, sumir);
  return sumir;
}
